import React from 'react';
import styled from 'styled-components';

const AppsSection = styled.section`
  width: 100%;
  padding: ${props => props.theme.spacing.mega} 0;
  background: ${props => props.theme.colors.background.secondary};
`;

const AppsContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing.large};
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: ${props => props.theme.fontSizes.hero};
  margin-bottom: ${props => props.theme.spacing.medium};

  background: linear-gradient(
    135deg,
    ${props => props.theme.colors.primary} 0%,
    ${props => props.theme.colors.neon.cyan} 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

const SectionSubtitle = styled.p`
  text-align: center;
  font-size: ${props => props.theme.fontSizes.large};
  color: ${props => props.theme.colors.text.secondary};
  margin-bottom: ${props => props.theme.spacing.xxlarge};
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
`;

const StoresGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: ${props => props.theme.spacing.xlarge};
  max-width: 800px;
  margin: 0 auto;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`;

const StoreCard = styled.div`
  background: ${props => props.theme.colors.background.card};
  border: 2px solid ${props => props.theme.colors.background.tertiary};
  border-radius: ${props => props.theme.borderRadius.large};
  padding: ${props => props.theme.spacing.xxlarge};
  text-align: center;
  transition: all ${props => props.theme.transitions.medium};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.theme.spacing.large};

  &:hover {
    transform: translateY(-5px);
    border-color: ${props => props.theme.colors.primary};
    box-shadow: ${props => props.theme.shadows.glowStrong};
  }
`;

const StoreBadge = styled.img`
  height: 60px;
  width: auto;
  filter: brightness(0.95);
  transition: all ${props => props.theme.transitions.fast};

  &:hover {
    filter: brightness(1.1);
    transform: scale(1.05);
  }
`;

const InstallButton = styled.a`
  display: inline-block;
  padding: ${props => props.theme.spacing.medium} ${props => props.theme.spacing.xlarge};
  font-size: ${props => props.theme.fontSizes.large};
  font-weight: ${props => props.theme.fontWeights.semibold};
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: ${props => props.theme.borderRadius.medium};
  background: linear-gradient(
    135deg,
    ${props => props.theme.colors.primary} 0%,
    ${props => props.theme.colors.primaryDark} 100%
  );
  color: ${props => props.theme.colors.background.primary};
  box-shadow: ${props => props.theme.shadows.glow};
  transition: all ${props => props.theme.transitions.medium};
  cursor: pointer;
  text-decoration: none;

  &:hover {
    transform: translateY(-3px);
    box-shadow: ${props => props.theme.shadows.glowStrong};
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    padding: ${props => props.theme.spacing.small} ${props => props.theme.spacing.large};
    font-size: ${props => props.theme.fontSizes.medium};
  }
`;

const MobileAppsSection: React.FC = () => {
  return (
    <AppsSection id="mobile-apps">
      <AppsContainer>
        <SectionTitle>Available on Mobile</SectionTitle>

        <StoresGrid>
          <StoreCard>
            <StoreBadge
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              alt="Download on App Store"
            />
            <InstallButton href="https://apps.apple.com" target="_blank" rel="noopener noreferrer">
              Install
            </InstallButton>
          </StoreCard>

          <StoreCard>
            <StoreBadge
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              alt="Get it on Google Play"
            />
            <InstallButton href="https://play.google.com" target="_blank" rel="noopener noreferrer">
              Install
            </InstallButton>
          </StoreCard>
        </StoresGrid>
      </AppsContainer>
    </AppsSection>
  );
};

export default MobileAppsSection;
